import {
  IconSize,
  iconStrokeWidthBySize,
  IconStyle,
  ShieldIconSize,
} from '../../icon_types';

type ShieldErrorIconProps = {
  id?: string;
  className?: string;
  size: IconSize | ShieldIconSize;
  color?: string;
  crossColor?: string;
  style: IconStyle;
};

const pathDsByStyleAndSize = {
  ['outline']: {
    '8': [
      'M4.94273 2.89958L3.99992 3.84238M3.99992 3.84238L3.05711 4.78519M3.99992 3.84238L3.05711 2.89958M3.99992 3.84238L4.94273 4.78519M3.99992 7.33335C3.99992 7.33335 6.66659 6.00002 6.66659 4.00002V1.66669L3.99992 0.666687L1.33325 1.66669V4.00002C1.33325 6.00002 3.99992 7.33335 3.99992 7.33335Z',
    ],
    '16': [
      'M9.8857 5.79909L8.00008 7.68471M8.00008 7.68471L6.11446 9.57033M8.00008 7.68471L6.11446 5.79909M8.00008 7.68471L9.8857 9.57033M8.00008 14.6666C8.00008 14.6666 13.3334 12 13.3334 7.99998V3.33331L8.00008 1.33331L2.66675 3.33331V7.99998C2.66675 12 8.00008 14.6666 8.00008 14.6666Z',
    ],
    '24': [
      'M14.8284 8.69867L12 11.5271M12 11.5271L9.17157 14.3555M12 11.5271L9.17157 8.69867M12 11.5271L14.8284 14.3555M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z',
    ],
    '32': [
      'M19.7712 11.5982L15.9999 15.3695M15.9999 15.3695L12.2287 19.1407M15.9999 15.3695L12.2287 11.5982M15.9999 15.3695L19.7712 19.1407M15.9999 29.3334C15.9999 29.3334 26.6666 24 26.6666 16V6.66669L15.9999 2.66669L5.33325 6.66669V16C5.33325 24 15.9999 29.3334 15.9999 29.3334Z',
    ],
  },
  ['filled']: {
    '8': [
      'M3.99992 7.33335C3.99992 7.33335 6.66659 6.00002 6.66659 4.00002V1.66669L3.99992 0.666687L1.33325 1.66669V4.00002C1.33325 6.00002 3.99992 7.33335 3.99992 7.33335Z',
      'M4.94281 2.89954L3.05719 4.78515M3.05719 2.89954L4.94281 4.78515',
    ],
    '16': [
      'M8.00008 14.6666C8.00008 14.6666 13.3334 12 13.3334 7.99998V3.33331L8.00008 1.33331L2.66675 3.33331V7.99998C2.66675 12 8.00008 14.6666 8.00008 14.6666Z',
      'M9.88562 5.79913L6.11438 9.57037M6.11438 5.79913L9.88562 9.57037',
    ],
    '24': [
      'M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z',
      'M14.8284 8.69867L9.17157 14.3555M9.17157 8.69867L14.8284 14.3555',
    ],
    '32': [
      'M15.9999 29.3334C15.9999 29.3334 26.6666 24 26.6666 16V6.66669L15.9999 2.66669L5.33325 6.66669V16C5.33325 24 15.9999 29.3334 15.9999 29.3334Z',
      'M19.7712 11.5982L12.2288 19.1407M12.2288 11.5982L19.7712 19.1407',
    ],
  },
};

const ShieldErrorIcon = (props: ShieldErrorIconProps) => {
  const {id, className, size, color, crossColor, style} = props;
  const paths = pathDsByStyleAndSize[style][size];
  const colorOptions = color || 'currentColor' || '#1E1E20';

  return (
    <svg
      id={id}
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none">
      {paths.map((d, index) => (
        <path
          key={index}
          d={d}
          stroke={
            style === 'outline'
              ? colorOptions
              : index === 0
              ? colorOptions
              : crossColor || 'white'
          }
          fill={style === 'filled' ? colorOptions : 'none'}
          strokeWidth={iconStrokeWidthBySize[size]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </svg>
  );
};

export default ShieldErrorIcon;
